<div id="{{id}}" class="page L-scrollY has-header has-footer-btn">
  <div class="header-page L-scrollY-header">
    <h1>{{title}}</h1>
  </div>
    <div class="inlineGroup fields">
        <field-file {(field)}="file" label="{{msg 'create.import'}}" accept-extentions="json"></field-file>
    </div>
  <ui-submit-cancel class="L-scrollY-footer-btn" {status}="saveStatus" submit-label="{{msg '_Import'}}"></ui-submit-cancel>
</div>
